module.exports = __webpack_public_path__ + "static/media/background1.3ada2fd6.png";